/**
 * Pure billing gate evaluation for freemium LOC reviews.
 */
export function evaluateBillingGate(input) {
    const { freeReviewLimit, completedReviewCount, billingCollectionReadyAt, billingCollectionFailedAt, } = input;
    const unlimited = freeReviewLimit < 0;
    const freeReviewsUsed = completedReviewCount;
    const freeReviewsRemaining = unlimited ? null : Math.max(0, freeReviewLimit - freeReviewsUsed);
    if (unlimited) {
        return {
            allowed: true,
            freeReviewsUsed,
            freeReviewLimit,
            freeReviewsRemaining,
            billingReady: billingCollectionReadyAt !== null,
            billingFailed: billingCollectionFailedAt !== null,
            blockedReason: null,
            failedAt: billingCollectionFailedAt?.toISOString() ?? null,
        };
    }
    if (freeReviewsUsed < freeReviewLimit) {
        return {
            allowed: true,
            freeReviewsUsed,
            freeReviewLimit,
            freeReviewsRemaining: freeReviewLimit - freeReviewsUsed,
            billingReady: billingCollectionReadyAt !== null,
            billingFailed: billingCollectionFailedAt !== null,
            blockedReason: null,
            failedAt: billingCollectionFailedAt?.toISOString() ?? null,
        };
    }
    if (!billingCollectionReadyAt) {
        return {
            allowed: false,
            freeReviewsUsed,
            freeReviewLimit,
            freeReviewsRemaining: 0,
            billingReady: false,
            billingFailed: false,
            blockedReason: 'BILLING_SETUP_REQUIRED',
            failedAt: null,
        };
    }
    if (billingCollectionFailedAt) {
        return {
            allowed: false,
            freeReviewsUsed,
            freeReviewLimit,
            freeReviewsRemaining: 0,
            billingReady: true,
            billingFailed: true,
            blockedReason: 'PAYMENT_METHOD_REQUIRED',
            failedAt: billingCollectionFailedAt.toISOString(),
        };
    }
    // Quota exhausted but billing is ready — freeReviewsRemaining is null because
    // the quota no longer governs access; billing covers continued use.
    return {
        allowed: true,
        freeReviewsUsed,
        freeReviewLimit,
        freeReviewsRemaining: null,
        billingReady: true,
        billingFailed: false,
        blockedReason: null,
        failedAt: null,
    };
}
/**
 * For UI copy like "X / Y free reviews used": {@link evaluateBillingGate} keeps
 * `freeReviewsUsed` as total qualifying reviews, which can exceed `freeReviewLimit`
 * after the free allowance is exhausted — so raw values can look like 14/10.
 * This caps the displayed numerator at the free allowance (max Y/Y when over).
 */
export function capFreeTierUsedForDisplay(freeReviewsUsed, freeReviewLimit) {
    if (freeReviewLimit < 0) {
        return freeReviewsUsed;
    }
    return Math.min(Math.max(0, freeReviewsUsed), freeReviewLimit);
}
//# sourceMappingURL=billing-gate.js.map